<template>
  <header class="header" id="header">
    <div class="hero-head">
      <nav class="navbar"><!-- is-fixed-top-->
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item" href="/">
              <img :src="require('../assets/img/logo-white.png')" alt="Logo">
            </a>
            <span class="navbar-burger burger" data-target="navbarMenu">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
          <div id="navbarMenu" class="navbar-menu">
            <div class="navbar-end">
              <a class="navbar-item" href="/"><!-- is-active -->
                Home
              </a>
              <!-- <a class="navbar-item">
                Autores
              </a> -->
              <a class="navbar-item" href="/titulos">
                Títulos
              </a>
              <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                  Categorias
                </a>
                <div class="navbar-dropdown">
                  <a class="navbar-item" v-bind:href="'/titulos/' + category['.key']" v-if="categories" v-for="category in categories" :key="category.key">{{category['.value']}}</a>
                  <!-- <hr class="navbar-divider">
                  <div class="navbar-item">
                    Version 0.7.0
                  </div> -->
                </div>
              </div>

              <div class="navbar-item">
                  <div class="field is-grouped is-grouped-multiline">
                    <p class="control">
                      <a class="button is-danger is-patreon" href="https://www.patreon.com/neolivros">
                        <strong>Apoia-nos no Patreon</strong>
                      </a>
                    </p>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </nav>
    </div>
    </header>
</template>

<script>
import { categoriesRef } from '../firebase_config'
export default {
  name: 'header',
  mounted: function () {
    var burger = document.querySelector('.burger')
    var menu = document.querySelector('#navbarMenu')
    burger.addEventListener('click', function () {
      burger.classList.toggle('is-active')
      menu.classList.toggle('is-active')
    })
    // var modal = document.querySelector('.modal-button')
    // var modalView = document.querySelector('#modal-ter')
    // modal.addEventListener('click', function () {
    //   modalView.classList.toggle('is-active')
    // })
  },
  firebase: {
    categories: {
      source: categoriesRef,
      asObject: false
    }
  }
}
</script>

<style lang="scss" scoped>
.hero.is-info .navbar-item, .hero.is-info .navbar-link {
    color: white;
}
.navbar-item.has-dropdown:hover .navbar-link, .navbar-item.has-dropdown.is-active .navbar-link {
  background-color: #506286; /* Dropdown active state */
}
.navbar-link:after {
   border-color: white; /* caret down */
}
.navbar-dropdown {
    background-color: #495979;
}
.navbar-dropdown .navbar-item {
  background-color: #495979;
}
.navbar-item {
  background-color: #3e4c69;
}
.hero.is-info a.navbar-item:hover, .hero.is-info a.navbar-item.is-active, .hero.is-info .navbar-link:hover, .hero.is-info .navbar-link.is-active {
  background-color: #506286;
}
@media screen and (max-width: 1023px) {
.hero.is-info .navbar-menu {
    background-color: #3e4c69;
}
}
@media screen and (max-width: 768px) {
  .hero.is-info.is-bold .navbar-menu {
      background-image: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue